/* eslint-disable ember/use-ember-data-rfc-395-imports */
import { type ModelRegistry } from 'ember-data/model';

import ApplicationAdapter from './application';

type VisitFetchType = 'upcoming' | 'previous';

interface Query {
  adapterOptions?: {
    type: VisitFetchType;
    visitorProfileId: string;
  };
}

const VISIT_FETCH_TYPE_MAP: Record<VisitFetchType, string> = {
  upcoming: 'upcoming-visits',
  previous: 'previous-visits',
};

export default class VisitCompositeAdapter extends ApplicationAdapter {
  urlForQuery<K extends keyof ModelRegistry>(query: Query, modelName: K): string {
    const { type, visitorProfileId } = query.adapterOptions ?? {};
    if (!type || !visitorProfileId) {
      return super.urlForQuery(query, modelName);
    }

    delete query.adapterOptions; // Clean up so it doesn't go in query params
    return `${this.buildURL()}/visitor-profiles/${visitorProfileId}/${VISIT_FETCH_TYPE_MAP[type]}`;
  }
}
